import * as React from 'react';

import { IconProps } from './types';

export const ArrowDownIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={forwardedRef}
    {...props}
  >
    <path
      d="M7.5 12L4 8.5H6V3H9V8.5H11L7.5 12Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
));
ArrowDownIcon.displayName = 'ArrowDownIcon';

export default ArrowDownIcon;
